// extracted by mini-css-extract-plugin
export default {"titleStat":"voteForm_titleStat__UWF-X"};